<template>
  <div class="s_title flex flex-direction">
    {{ title }}
    <img
      class="title-border"
      src="../../../assets/images/guide/title-border.png"
    />
  </div>
</template>

<script>
export default {
  name: "stitle",
  props: {
    //标题
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.s_title {
  font-size: 18px;
  font-family: Microsoft YaHei-Light;
  font-weight: 400;

  color: #151e26;
  line-height: 24px;
  .title-border {
    margin-top: 7px;
    height: 3px;
    width: 78px;
  }
}
@media (max-width: 992px) {
  .s_title {
    font-size: 28px;
    font-family: Microsoft YaHei-Light;
    font-weight: 400;
    color: #151e26;

    .title-border {
      margin-top: 11px;
      width: 117px;
      height: 5px;
    }

    padding-bottom: 14px;
  }
}
</style>
